import {Navigate, Route, Routes, useLocation, useParams} from 'react-router-dom';
import {useEffect} from 'react';
import {setDarkModeForUserPreference} from 'components/DarkModeButton/DarkModeButton';
import {
  AppointmentConfirmationScreenContainer,
  AppointmentManagementScreenContainer,
  InsomniaCheckoutScreenContainer,
  InsomniaSurveyScreenContainer,
} from 'InsomniaConfigScreens';

const RootRedirect = () => {
  const location = useLocation();
  // Insomnia intake is the default landing surface; preserve query params.
  // The OSA funnel is still reachable directly at /osa/start.
  const to = `/start${location.search}`;
  return <Navigate to={to} replace />;
};

const ReferralCodeRedirect = () => {
  const {referralCode} = useParams<{referralCode: string}>();
  const location = useLocation();
  // Redirect to /start and pass referral code via location state
  // Preserve query parameters when redirecting
  const to = `/start${location.search}`;
  return <Navigate to={to} state={{referralCode}} replace />;
};

export const InsomniaRoutes = () => {
  useEffect(() => {
    setDarkModeForUserPreference();
  }, []);

  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="r/:referralCode" element={<ReferralCodeRedirect />} />
      <Route index path="start" element={<InsomniaSurveyScreenContainer />} />
      <Route path="checkout" element={<InsomniaCheckoutScreenContainer />} />
      <Route path="appointment-confirmation" element={<AppointmentConfirmationScreenContainer />} />
      <Route path="appt" element={<AppointmentManagementScreenContainer />} />
    </Routes>
  );
};
